import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 2rem;
  & .right-items {
    width: 25%;
    position: relative;
    top: 0rem;
    right: 0rem;
  }
  & .right-items-fixed {
    width: 25%;
    position: fixed;
    top: 9.2rem;
    right: 0rem;
  }
  & .left-items {
    padding-right: 5rem;
    width: 75%;
  }
`;
